module.exports = __webpack_public_path__ + "img/huanyuan.25efd1a0.gif";